/**
 * @fileoverview Default/predefined templates for the platform
 */
/**
 * Get default/predefined templates
 */
export const getDefaultTemplates = () => {
    const now = new Date();
    return [
        {
            id: 'default_certificate',
            name: 'Certificado Básico',
            description: 'Plantilla básica para certificados con campos comunes',
            fields: [
                {
                    id: 'field_email',
                    name: 'recipientEmail',
                    label: 'Email del Destinatario',
                    type: 'email',
                    required: true,
                    placeholder: 'destinatario@ejemplo.com',
                    order: 0,
                },
                {
                    id: 'field_name',
                    name: 'recipientName',
                    label: 'Nombre / Razón Social',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre completo o razón social',
                    order: 1,
                },
                {
                    id: 'field_2',
                    name: 'license',
                    label: 'Licencia / ID',
                    type: 'text',
                    required: true,
                    placeholder: 'Número de licencia o identificación',
                    order: 2,
                },
                {
                    id: 'field_3',
                    name: 'issueDate',
                    label: 'Fecha de Emisión',
                    type: 'date',
                    required: true,
                    defaultValue: new Date().toISOString().split('T')[0],
                    order: 3,
                },
                {
                    id: 'field_4',
                    name: 'expirationDate',
                    label: 'Fecha de Vencimiento',
                    type: 'date',
                    required: false,
                    order: 4,
                },
                {
                    id: 'field_5',
                    name: 'observations',
                    label: 'Observaciones',
                    type: 'textarea',
                    required: false,
                    placeholder: 'Notas adicionales',
                    order: 5,
                },
            ],
            metadata: {},
            createdAt: now,
            updatedAt: now,
            createdBy: 'system',
            isPublic: true,
            category: 'certificate',
        },
        {
            id: 'default_course',
            name: 'Certificado de Curso',
            description: 'Plantilla para certificados de cursos y capacitaciones',
            fields: [
                {
                    id: 'field_email',
                    name: 'recipientEmail',
                    label: 'Email del Destinatario',
                    type: 'email',
                    required: true,
                    placeholder: 'destinatario@ejemplo.com',
                    order: 0,
                },
                {
                    id: 'field_name',
                    name: 'studentName',
                    label: 'Nombre / Razón Social',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre completo o razón social',
                    order: 1,
                },
                {
                    id: 'field_2',
                    name: 'courseName',
                    label: 'Nombre del Curso',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre del curso completado',
                    order: 2,
                },
                {
                    id: 'field_3',
                    name: 'completionDate',
                    label: 'Fecha de Finalización',
                    type: 'date',
                    required: true,
                    defaultValue: new Date().toISOString().split('T')[0],
                    order: 3,
                },
                {
                    id: 'field_4',
                    name: 'hours',
                    label: 'Horas de Curso',
                    type: 'number',
                    required: false,
                    placeholder: 'Total de horas',
                    order: 4,
                },
                {
                    id: 'field_5',
                    name: 'instructor',
                    label: 'Instructor',
                    type: 'text',
                    required: false,
                    placeholder: 'Nombre del instructor',
                    order: 5,
                },
                {
                    id: 'field_6',
                    name: 'grade',
                    label: 'Calificación',
                    type: 'select',
                    required: false,
                    options: ['Aprobado', 'Sobresaliente', 'Excelente'],
                    order: 6,
                },
            ],
            metadata: {},
            createdAt: now,
            updatedAt: now,
            createdBy: 'system',
            isPublic: true,
            category: 'course',
        },
        {
            id: 'default_technical',
            name: 'Certificado Técnico',
            description: 'Plantilla para certificados técnicos con datos técnicos',
            fields: [
                {
                    id: 'field_email',
                    name: 'recipientEmail',
                    label: 'Email del Destinatario',
                    type: 'email',
                    required: true,
                    placeholder: 'destinatario@ejemplo.com',
                    order: 0,
                },
                {
                    id: 'field_name',
                    name: 'recipientName',
                    label: 'Nombre / Razón Social',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre completo o razón social',
                    order: 1,
                },
                {
                    id: 'field_2',
                    name: 'technicalData',
                    label: 'Datos Técnicos',
                    type: 'textarea',
                    required: true,
                    placeholder: 'Especificaciones técnicas, modelos, números de serie, etc.',
                    order: 2,
                },
                {
                    id: 'field_3',
                    name: 'workOrder',
                    label: 'Orden de Trabajo',
                    type: 'text',
                    required: false,
                    placeholder: 'Número de orden',
                    order: 3,
                },
                {
                    id: 'field_4',
                    name: 'inspectionDate',
                    label: 'Fecha de Inspección',
                    type: 'date',
                    required: true,
                    defaultValue: new Date().toISOString().split('T')[0],
                    order: 4,
                },
                {
                    id: 'field_5',
                    name: 'status',
                    label: 'Estado',
                    type: 'select',
                    required: true,
                    options: ['Aprobado', 'Rechazado', 'Pendiente', 'En Reparación'],
                    order: 5,
                },
                {
                    id: 'field_6',
                    name: 'notes',
                    label: 'Notas Adicionales',
                    type: 'textarea',
                    required: false,
                    placeholder: 'Observaciones y notas',
                    order: 6,
                },
            ],
            metadata: {},
            createdAt: now,
            updatedAt: now,
            createdBy: 'system',
            isPublic: true,
            category: 'technical',
        },
        {
            id: 'default_aircraft_repair',
            name: 'Taller de Reparación de Aeronaves',
            description: 'Plantilla especializada para certificados de talleres de reparación y mantenimiento de aeronaves',
            fields: [
                {
                    id: 'field_email',
                    name: 'recipientEmail',
                    label: 'Email del Cliente',
                    type: 'email',
                    required: true,
                    placeholder: 'cliente@ejemplo.com',
                    order: 0,
                },
                {
                    id: 'field_name',
                    name: 'recipientName',
                    label: 'Nombre / Razón Social del Cliente',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre completo o razón social',
                    order: 1,
                },
                {
                    id: 'field_aircraft_model',
                    name: 'aircraftModel',
                    label: 'Modelo de Aeronave',
                    type: 'text',
                    required: true,
                    placeholder: 'Ej: Cessna 172, Boeing 737, etc.',
                    order: 2,
                },
                {
                    id: 'field_registration',
                    name: 'aircraftRegistration',
                    label: 'Matrícula de Aeronave',
                    type: 'text',
                    required: true,
                    placeholder: 'Ej: LV-ABC, N123AB',
                    order: 3,
                },
                {
                    id: 'field_repair_type',
                    name: 'repairType',
                    label: 'Tipo de Reparación',
                    type: 'select',
                    required: true,
                    options: [
                        'Inspección 100 Horas',
                        'Inspección Anual',
                        'Inspección Pre-Vuelo',
                        'Mantenimiento Mayor',
                        'Reparación Estructural',
                        'Overhaul Motor',
                        'Revisión de Sistemas',
                        'Reparación de Aviónica',
                        'Reparación de Fuselaje',
                        'Reparación de Alas',
                        'Reparación de Tren de Aterrizaje',
                        'Otro'
                    ],
                    order: 4,
                },
                {
                    id: 'field_work_order',
                    name: 'workOrderNumber',
                    label: 'Número de Orden de Trabajo',
                    type: 'text',
                    required: true,
                    placeholder: 'OT-2024-001',
                    order: 5,
                },
                {
                    id: 'field_repair_date',
                    name: 'repairDate',
                    label: 'Fecha de Reparación',
                    type: 'date',
                    required: true,
                    defaultValue: new Date().toISOString().split('T')[0],
                    order: 6,
                },
                {
                    id: 'field_technician',
                    name: 'technicianName',
                    label: 'Técnico Responsable',
                    type: 'text',
                    required: true,
                    placeholder: 'Nombre del técnico certificado',
                    order: 7,
                },
                {
                    id: 'field_technician_license',
                    name: 'technicianLicense',
                    label: 'Licencia del Técnico',
                    type: 'text',
                    required: false,
                    placeholder: 'Número de licencia del técnico',
                    order: 8,
                },
                {
                    id: 'field_repair_description',
                    name: 'repairDescription',
                    label: 'Descripción de la Reparación',
                    type: 'textarea',
                    required: true,
                    placeholder: 'Descripción detallada del trabajo realizado',
                    order: 9,
                },
                {
                    id: 'field_parts_replaced',
                    name: 'partsReplaced',
                    label: 'Partes Reemplazadas',
                    type: 'textarea',
                    required: false,
                    placeholder: 'Lista de partes, componentes o piezas reemplazadas',
                    order: 10,
                },
                {
                    id: 'field_hours',
                    name: 'flightHours',
                    label: 'Horas de Vuelo',
                    type: 'number',
                    required: false,
                    placeholder: 'Total de horas de vuelo de la aeronave',
                    order: 11,
                },
                {
                    id: 'field_next_inspection',
                    name: 'nextInspectionDate',
                    label: 'Próxima Inspección',
                    type: 'date',
                    required: false,
                    placeholder: 'Fecha de próxima inspección requerida',
                    order: 12,
                },
                {
                    id: 'field_compliance',
                    name: 'complianceStandards',
                    label: 'Normativas Cumplidas',
                    type: 'textarea',
                    required: false,
                    placeholder: 'Normativas, regulaciones o estándares cumplidos (FAA, EASA, etc.)',
                    order: 13,
                },
                {
                    id: 'field_observations',
                    name: 'observations',
                    label: 'Observaciones',
                    type: 'textarea',
                    required: false,
                    placeholder: 'Observaciones adicionales, recomendaciones o notas',
                    order: 14,
                },
            ],
            metadata: {},
            createdAt: now,
            updatedAt: now,
            createdBy: 'system',
            isPublic: true,
            category: 'aircraft_repair',
        },
    ];
};
